<form
  [formGroup]="form"
  [style.background-color]="footer().backgroundColor()"
  [style.color]="footer().textColor()"
  class="chat-footer-container"
  fxLayoutAlign="space-between center"
  fxLayoutGap="10px"
>
  <mat-form-field fxFlex="100%" hideRequiredMarker>
    <mat-label [style.color]="footer().textColor?.()">{{ $safeNavigationMigration(footer().label?.()) | translate }}</mat-label>
    <textarea
      #autosize
      [style.color]="footer().textColor?.()"
      cdkAutosizeMaxRows="5"
      cdkAutosizeMinRows="0"
      cdkTextareaAutosize
      class="chat-footer-input"
      formControlName="message"
      matInput
      maxlength="300"
      (keyup.enter)="sendMessage()"
      (keydown)="handleKeydown($event, autosize)"
    ></textarea>
  </mat-form-field>

  <button (click)="sendMessage()" [disabled]="form.invalid" class="chat-footer-button" mat-icon-button type="submit">
    <mat-icon>{{ footer().action?.()?.icon?.() }}</mat-icon>
  </button>
</form>
